<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">FAQ Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editFaq">Edit FAQ</button>
                </div>
            </div>
            <div class="table-responsive" v-if="faq">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{faq.faqId}}</td>
                    </tr>
                  <tr>
                    <th>Section Header</th>
                    <td>{{faq.faqHeader}}</td>
                  </tr>
                  <tr>
                    <th>Question</th>
                    <td>{{faq.question}}</td>
                  </tr>
                  <tr>
                    <th>Answer</th>
                    <td>{{faq.response}}</td>
                  </tr>
                  <tr>
                  <tr>
                    <th>Image</th>
                    <td ><img v-if="faq.faqImageUrl" class="table-thumbnail" :src="faq.faqImageUrl" :title="faq.faqImageUrl" />
                    </td>
                  </tr>
                  <tr>
                    <th>Vidoe Code</th>
                    <td>{{faq.faqVideoUrl}}</td>
                  </tr>
                  <tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="faq.active">Active</td>
                        <td v-else>Inactive</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewFaq',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDFAQ', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedGreeting)
            this.faq = this.selectedFaq;
        })
    },
    data () {
        return {
          faq: {}
        }
    },
    methods: {
        editFaq(){
            this.$router.push({ name: 'EditFaq', params: { id: this.faq.faqId}})
        },
    },
    computed: {...mapGetters([
        'selectedFaq'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Faqs/FaqDetails.vue